export default __webpack_public_path__ + "static/ANT-ebef1df074651942d195f616db7f959b.png";